import tw, { styled } from "twin.macro"

export const List = styled.div`
  ${tw`flex flex-row items-center justify-center mlg:justify-end py-1-6 w-full`}
`

export const ListItem = tw.div`block mx-0-8 last-of-type:mr-0 text-white`
